import { render } from "./AddDeleteButtons.vue?vue&type=template&id=161e7c52&ts=true"
import script from "./AddDeleteButtons.vue?vue&type=script&lang=ts"
export * from "./AddDeleteButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__